import { useAuth } from "@/hooks/useAuth";
import { $api } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";

export function useProjectDetail(projectId: string) {
  const { backendToken } = useAuth();
  return $api.useQuery(
    "get",
    "/api/v1/projects/{project_id}",
    { params: { path: { project_id: projectId } } },
    {
      staleTime: 5 * 60 * 1000,
      placeholderData: keepPreviousData,
      enabled: !!backendToken && !!projectId,
    },
  );
}
